// extracted by mini-css-extract-plugin
module.exports = {"factor_detail_modal_wrapper":"DetailModal_factor_detail_modal_wrapper__1iuVr"};